export default {"src":"/_next/static/media/educationalt.6b08784a.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};